import React, { useCallback, useEffect, useState } from "react";
import { Box, Tag, Text, useColorModeValue } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { AiFillDelete } from "react-icons/ai";
import { FaPlus } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import ColumnTable from '../embrillTable/ColumnTable';
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import prJson from "components/jsonData/purchase.json";
import {  salesItemDataColumns } from "../embrillTable/variables/colData";
import { fetchAsyncDeleteSalesItem } from "redux/salesItemSlice";
import { fetchAsyncGetSalesItem } from "redux/salesItemSlice";
import AddSalesItemForm from "components/allForm/SalesItem/addSalesItemForm";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
import { taxOptions } from "components/allForm/PurchaseItem/selectedOptions";
import CurrencySelectField from "components/allForm/SalesItem/currencySelected";
import { allCurrency } from "components/allForm/SalesItem/currencyJson";
import useSearch from "hooks/useSearch";
import { setCurrency } from "redux/slices/searchTextSlice";
const SalesItemModule = () => {
  const dispatch = useDispatch();
  const [itemListData, setItemListData] = useState([]);
  const currUser = useSelector((state) => state.auth.currUser);
  const [role,setRole] = useState('')  
  const {searchText} = useSelector((state) => state.searchValue); 
  const {currencyCode} = useSelector((state) => state.currency);
  const { performSearch } = useSearch();

  useEffect(()=>{
    if(currUser && currUser?.auth){
      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Sales Items');
      if(roleObj){
        setRole(roleObj?.access)
      }
    }
   
  },[currUser])

  const [openItemModal, setOpenItemModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [itemEditData, setItemEditData] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpenItemModal = () => {
    setOpenItemModal(true);
  };

  const handleCloseItemModal = () => {
    setOpenItemModal(false);
    setOpenEditModal(false);
    setItemEditData(null);
    handlerRefreshData();
  };

  const handlerRefreshData = useCallback(
    () => {
      performSearch(searchText);
    },
    [searchText,performSearch]
  );


  
  const itemList = useSelector((state) => state.salesItemData);

  const deleteItem = (data) => {
    dispatch(fetchAsyncDeleteSalesItem(data._id)).then(() => {
      handlerRefreshData();
    });
  };
  
  useEffect(() => {
    if (itemList && itemList.length > 0) {
        const tableData = itemList.map((data, index) => {
            const iStatetaxRate = taxOptions.find((opt)=>opt.id === data.istr)
            return {
              _id:data._id,
              no: index + 1,
              name:(
                <span 
                  style={{ cursor: "pointer",color:'blue'}}
                >
                  {data?.name}
                </span>
              ),
              type: data?.typ,
              clientName:(
                <span 
                  style={{ cursor: "pointer",color:'blue'}}
                >
                  {data?.cId?.clName || "-"}
                </span>
              ),
              taxRate:iStatetaxRate ? iStatetaxRate?.label : '-',
              currency:<Tag bg="lightBlue" color="white">{data?.cur}</Tag>,
              itemcode:data?.typ === 'goods' ? data?.hCd : data?.sCd,
              sortSellPrice:Number(data?.prc) || 0,
              sellingPrice:<Box display="flex" >
              <span
                  style={{fontWeight:'600'}}
                  className={ data?.prc ? 'green' :''}
                >
                  {formatAmountIndianRupees(data?.prc ? parseFloat(data?.prc) : 0)} {currencySymbolByCode(data?.cur|| "INR")}
                </span>
              
               </Box>,
              action: (
                <div className="d-flex">
             <MdModeEdit
                className="me-2"
                color="blue"
                size={16}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  handleEditClick(e,data._id)
                }}
              />
              
                  {role === "Admin" ? (
                    <AiFillDelete
                      style={{ cursor: "pointer",marginLeft:'10px' }}
                      size={16}
    
                      onClick={(e) => {
                        e.preventDefault();
                        ConfirmationDialog({
                          title: prJson.confirm.deleteItem,
                          text:prJson.text.undone,
                          icon: 'warning',
                          confirmButtonText: 'Delete',
                          cancelButtonText: 'Cancel',
                          onConfirm: () => {
                            deleteItem(data);
                          },
                        });
                      }}
                    />
                  ):'No Access'}
                </div>
              ),
            };
          });
      setItemListData(tableData);
    } else {
      setItemListData([]);
    }
  }, [itemList]);


  const handleRowClick = (e,_id)=>{
    e.stopPropagation();
    const data = itemList.filter((item)=> item?._id === _id)
    setOpenEditModal(true);
    setItemEditData(data[0]);
    handleOpenItemModal();
  }

  const handleEditClick = (e,_id)=>{
    e.stopPropagation();
    const data = itemList.filter((item)=> item?._id === _id)
    setOpenEditModal(true);
    setItemEditData(data[0]);
    handleOpenItemModal();
  }

useEffect(() => {
  setLoading(true); 
  dispatch(fetchAsyncGetSalesItem())
    .then(() => {
      setLoading(false); 
    })
    .catch((error) => {
      setLoading(false); 
    });
  }, []);

  const handleTotalItemByCurrency = (code)=>{
    performSearch(searchText,"","","",code);
  }
  const textColor = useColorModeValue("secondaryGray.900", "white");


   // If loading, return a spinner
   if (loading) {
    return (
      <SpinnerLoader/>
    );
  }
  return (
    <>
      <Box display="flex" className="mx-0" justifyContent="space-between">
      <Box display="flex">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          mt={5}
          mx={2}
        >
          Sales Items
        </Text>
        <div className="mx-1 mt-3">
            <CurrencySelectField
              options={allCurrency}
              placeHolder=""
              defaultValue={allCurrency.find((item)=>item.code === currencyCode)}
              isSearchable
              onChange={(newValue) => {
                handleTotalItemByCurrency(newValue?.code || "INR")             
              }}
            />
          </div>
        </Box>
        <Box display="flex" mt={2} className="add-new-btn">
          <Box
            display="flex"
            alignItems="center"
            className="new-btn"
            onClick={handleOpenItemModal}
          >
            <FaPlus size={12} className="new-plus-icon"/> New
          </Box>
        </Box>
      </Box>
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        <ColumnTable
          columnsData={salesItemDataColumns}
          tableData={itemListData}
          type="SalesItems"
          role={role}
          expenseType = "SalesItems"
          openInfoModal = {handleRowClick}
        />
      </Box>
      {openItemModal && (
        <AddSalesItemForm
        isOpen={openItemModal}
          closeModal={() => {
            handleCloseItemModal();
          }}
          isEdit={openEditModal}
          editData={itemEditData}
          listItemBtn={false}
        />
      )}
     
    </>
  );
};

export default SalesItemModule;
